import { callApi } from './ApiClient';

const getIndustryCategoryList = (data, dispatch) => {
  return callApi('GET', `/industry_categories`, data, dispatch);
}

export const IndustryCategoryApi = {
  getIndustryCategoryList,
};



// WEBPACK FOOTER //
// ./src/redux/api/IndustryCategoryApi.js